<div
  class="text-center relative bg-blue color-light border-radius-5 overflow-hidden m-a card-container"
  style="max-width: fit-content">
  <!-- HEADER -->
  <cp-widget-header text="Continue Your Journey" icon="briefcase-2" [isAbsolutePosition]="true" />
  <button
    pButton
    class="p-button p-button-primary p-button-outlined small icon-only close-button"
    (click)="discard()">
    <shared-icon icon="cross" height="1rem" width="1rem" class="fill-light" />
  </button>

  <!-- BODY-->
  <div class="widget-base-layout text-center px-5 pt-5">
    <h1 class="pt-4">
      @if (
        (selectClientUserRemainingProperties$ | async) ===
        (selectClientUserDeclaredNumberOfProperties$ | async)
      ) {
        Get your {{ selectClientUserRemainingProperties$ | async }} properties monitored
      } @else {
        Almost there!
        <br />
        {{ selectPropertiesNumber$ | async }}
        {{ (selectPropertiesNumber$ | async) === 1 ? "property" : "properties" }} added
      }
    </h1>
    <img class="widget-img m-a" src="assets/images/landlord-properties.png" />
    <div class="text-14">
      @if (
        (selectClientUserRemainingProperties$ | async) ===
        (selectClientUserDeclaredNumberOfProperties$ | async)
      ) {
        You’ve told us you own {{ selectClientUserDeclaredNumberOfProperties$ | async }} properties.
        Add them now, and we’ll track your mortgages to make sure you’re always getting the best
        deal.
      } @else {
        You’ve added {{ selectPropertiesNumber$ | async }}
        {{ (selectPropertiesNumber$ | async) === 1 ? "property" : "properties" }}. Just
        {{ selectClientUserRemainingProperties$ | async }} more to go for us to monitor all your
        mortgages.
      }
    </div>

    <div class="m-a pb-5">
      <button pButton class="p-button p-button-primary" (click)="addPropertyRedirect()">
        Add property
      </button>
    </div>
  </div>
</div>
